import { ConditionalExpr } from '@angular/compiler';
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { ResponseMessage } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { MovementOrderRequest } from '../../model/sac-client.model';

@Component({
  selector: 'app-create-moving-order',
  templateUrl: './create-moving-order.component.html',
  styleUrls: ['./create-moving-order.component.scss']
})
export class CreateMovingOrderComponent implements OnInit {

  withTransport: boolean;

  responseMessages: ResponseMessage[];

  selectedVehicle: number;

  selectedTransport: number;

  targetStationId: number;

  constructor(
    public translationService: TranslationService,
    private httpService: HttpService,
    private tmcContextService: TmcContextService,
    private dialog: MatDialogRef<CreateMovingOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.targetStationId = this.data.station.id;
  }

  get createMovementOrderEnabled(): boolean {
    return this.selectedVehicle != null;
  }

  createMovementOrder() {

    const movementOrderRequest = new MovementOrderRequest({
      transportId: this.selectedTransport != null ? this.selectedTransport : null,
      vehicleId: this.selectedVehicle != null ? this.selectedVehicle : null,
      targetStationId: this.targetStationId
    });

    console.log('movement order is', movementOrderRequest);

    this.httpService.postWithContext<ServiceResponse>(environment.sacClientEndpoint + '/create-moving-order', movementOrderRequest).subscribe(
      response => {

        this.tmcContextService.forceRefreshOfStationUsages();
        this.responseMessages = response.responseMessages;

        this.dialog.close(true);

      }, error => {
        console.log('Unexpected error' + error);
      }
    );

  }

  vehicleSelected(vehicleId: number) {
    this.selectedVehicle = vehicleId;
  }

  transportSelected(transportId: number) {
    this.selectedTransport = transportId;
  }

}
